module.exports = __webpack_public_path__ + "img/table.d098d947.svg";